import { useEffect, useState } from "react";
import { Users, FileText, Calendar, Clock } from "lucide-react";
import { api } from "../api";
import { Card, PageHeader, formatDate } from "../ui";

export default function AdminDashboard() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/admin/dashboard").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data)
    return (
      <div className="text-sm text-slate-500">Carregando painel...</div>
    );

  return (
    <div data-testid="admin-dashboard">
      <PageHeader
        title="Painel Administrativo"
        subtitle="Visão geral da ABLEMP — associados, arquivos e reuniões."
      />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <Stat
          icon={Clock}
          label="Pendentes"
          value={data.associados.pendentes}
          accent="#FEDF00"
          dark
          testid="card-pending"
        />
        <Stat
          icon={Users}
          label="Associados ativos"
          value={data.associados.ativos}
          accent="#009B3A"
          testid="card-active"
        />
        <Stat
          icon={Users}
          label="Inativos"
          value={data.associados.inativos}
          accent="#dc2626"
          testid="card-inactive"
        />
        <Stat
          icon={FileText}
          label="Arquivos enviados"
          value={data.arquivos}
          accent="#002776"
          testid="card-files"
        />
        <Stat
          icon={Calendar}
          label="Pautas pendentes"
          value={data.pautas_pendentes}
          accent="#FEDF00"
          dark
          testid="card-agenda"
        />
        <Stat
          icon={Calendar}
          label="Atas registradas"
          value={data.atas}
          accent="#475569"
          testid="card-minutes"
        />
      </div>

      <Card className="mt-6 p-6">
        <div className="text-[11px] uppercase tracking-[0.25em] text-slate-500">
          Ações rápidas
        </div>
        <h3 className="mt-2 font-serif-display text-2xl">
          O que você quer fazer agora?
        </h3>
        <div className="mt-5 flex gap-2 flex-wrap">
          <a
            href="/admin/associados"
            className="px-4 py-2 bg-[#0A0F14] text-white text-[11px] uppercase tracking-[0.22em] hover:bg-[#002776]"
          >
            Aprovar cadastros
          </a>
          <a
            href="/admin/arquivos"
            className="px-4 py-2 border border-slate-300 text-[11px] uppercase tracking-[0.22em] hover:border-[#002776]"
          >
            Enviar boletos / documentos
          </a>
          <a
            href="/admin/reunioes"
            className="px-4 py-2 border border-slate-300 text-[11px] uppercase tracking-[0.22em] hover:border-[#002776]"
          >
            Gerenciar reuniões
          </a>
          <a
            href="/admin/eventos"
            className="px-4 py-2 border border-slate-300 text-[11px] uppercase tracking-[0.22em] hover:border-[#002776]"
          >
            Calendário de eventos
          </a>
          <a
            href="/admin/estatuto"
            className="px-4 py-2 border border-slate-300 text-[11px] uppercase tracking-[0.22em] hover:border-[#002776]"
          >
            Atualizar estatuto
          </a>
        </div>
      </Card>
    </div>
  );
}

const Stat = ({ icon: Icon, label, value, accent, dark, testid }) => (
  <Card className="p-5" testid={testid}>
    <div
      className="h-10 w-10 grid place-items-center rounded-sm"
      style={{
        background: accent + (dark ? "" : "12"),
        color: dark ? "#0A0F14" : accent,
      }}
    >
      <Icon size={18} strokeWidth={1.6} />
    </div>
    <div className="mt-4 font-serif-display text-3xl leading-none">{value}</div>
    <div className="mt-1 text-[11px] uppercase tracking-[0.22em] text-slate-500">
      {label}
    </div>
  </Card>
);
